import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, Grid, Typography, Container } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import OpaqueLoading from './opaqueLoading/opaqueLoading';

export default function SelectParty({partyType,choosePartyType,chooseParty,setTab,setOwner,partyId,ownerId,editMode,setParentOrderMode}) {
  const [rsm, setRsm] = useState('');
  const [user,setUSer]=useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [asm, setAsm] = useState('');
  const [rm, setRm] = useState('');
  const [loading, setLoading] = useState(false);
  const [party, setParty] = useState('');
  const [rsmOptions,setRsmOptions] = useState(['RSM 1', 'RSM 2', 'RSM 3']);
  const [asmOptions,setAsmOptions] = useState(['ASM 1', 'ASM 2', 'ASM 3']);
  const [rmOptions,setRmOptions] = useState(['RM 1', 'RM 2', 'RM 3']);
  const [partyTypeOptions,setPartyTypeOptions] = useState(['School', 'Distributor']);
  const [partyOptions,setPartyOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectPartyTab,setSelectPartyTab]=useState(false)
  const [hasSearched,setHasSearched]=useState(false);
  const [orderMode, setOrderMode] = useState("rm");


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getUser = async (id,role) => {
    const body = { userId: id };
    try {
      setLoading(true);
        const response = await window.Platform.database.getUsersBasedOnManager(body);
        if (response) {
            
            if(role=='rsm'){
                setRsm(id)
                setAsm("")
                setAsmOptions(response.data)
            }else if(role=='asm'){
                setAsm(id)
                setRm("")
                setRmOptions(response.data)
            }
        }
    } catch (error) {
        console.error("Error fetching orders:", error);
    }
    finally{
      setLoading(false);
    }
};

async function getAllRsm(role) {
    const body = { role:role };
    try {
      setLoading(true);
        const response = await window.Platform.database.fetchEmployees(0,role);
        if (response) {
          if(editMode){
            setRmOptions(response.data)
            setRm(ownerId)
            selectEditPartyType()
           
          }else{
            setRsm("")
            console.log(response);
            setRsmOptions(response.data)
          }
        }
    } catch (error) {
        console.error("Error fetching orders:", error);
    }
    finally{
      setLoading(false);
    }
}

async function selectPartyType(){
  if(orderMode == ""){
    window.alert("Please select Order Mode");
    return;
  }
  if(!rsm){
    window.alert("Please select HO");
    return;
  }
  if(!asm){
    window.alert("Please select ARM");
    return;
  }
  if(orderMode == "rm" && !rm){
    window.alert("Please select RM");
    return;
  }
 try {
   setLoading(true);
   setParentOrderMode(orderMode);
  
  let body = {
    "pageNumber": page, // Backend may use 0-based indexing
    "recordPerPage": rowsPerPage,
    "ownerId": orderMode == "direct" ? "" : rm,
    asm: asm,
rsm:rsm,
status:"active",
  };


    if(partyType.toLowerCase()=='school'){
      const response = await window.Platform.database.getSchool(body);
      if (response) {
          setPartyOptions(response.data)
          setTotalCount(response.data1)
          setSelectPartyTab(true);
          
          setLoading(false);
      }
    }else{
      const response = await window.Platform.database.getDistributorA(body);
      if (response) {
          setPartyOptions(response.data)
          setTotalCount(response.data1)
          setSelectPartyTab(true);
          setLoading(false);
      }
    }
 } catch (error) {
    console.error("Error fetching parties:", error);
    setPartyOptions([]);
    setTotalCount(0);
    window.NotificationUtils.showError("Failed to fetch parties. Please try again.");

 }
 finally{
    setLoading(false);
 }
}

async function selectEditPartyType(){
  
  let body = {
   id:partyId
  };

    console.log(partyType,"dadad");
    if(partyType.toLowerCase()=='school'){
      const response = await window.Platform.database.getSchoolById(body);
      if (response) {
          console.log(response.data[0])
          chooseParty(response.data[0]);setTab(1)
          
          
      }
    }else{
      const response = await window.Platform.database.getDistributorByID(body);
      if (response) {
        chooseParty(response.data[0]);setTab(1)
      }
    }
}
useEffect(()=>{
  if(hasSearched){
    selectPartyType()
  }
},[page, rowsPerPage])

useEffect(()=>{
  setRsm("");
  setAsm("");
  setRm('');
  setOwner('');
},[orderMode])


useEffect(()=>{
    if(editMode){
      getAllRsm('se')
    }else{
if(user.role.includes('admin')){
getAllRsm('rsm')
}else{
  getUser(user.id,user.role)
}
    }

},[])


  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      {loading && <OpaqueLoading />}
      {!selectPartyTab&&<div>
        <FormControl className='my-2' fullWidth>
              <InputLabel>{"Select Order Mode"}</InputLabel>
              <Select value={orderMode}  label={"Select Order Mode"} onChange={(e)=>{setOrderMode(e.target.value);}}>
                  <MenuItem key={1} value=""> Select</MenuItem>
                  <MenuItem key={3} value="rm"> RM Created</MenuItem>
                  <MenuItem key={2} value="direct"> Direct Order</MenuItem>
              </Select>
              </FormControl>
            {!editMode&&user.role.includes('admin')&&<FormControl fullWidth>
              <InputLabel>{"Select HO"}</InputLabel>
              <Select value={rsm}  label={"Select HO"} onChange={(e)=>getUser(e.target.value,"rsm")}>
                {rsmOptions.map((option, i) => (
                  <MenuItem key={i} value={option?.id}>{option.name} - {option.username}</MenuItem>
                ))}
              </Select>
              </FormControl>}
              {!editMode&&(user.role.includes('admin')||user.role=='rsm')&&<FormControl className='my-2' fullWidth>
              <InputLabel>{"Select ARM"}</InputLabel>
              <Select value={asm}  label={"Select ARM"} onChange={(e)=>{getUser(e.target.value,"asm");setOwner(e.target.value)}}>
                {asmOptions.map((option, i) => (
                  <MenuItem key={i} value={option?.id}>{option.name} - {option.username}</MenuItem>
                ))}
              </Select>
              </FormControl>}
              {orderMode == "rm" && <FormControl fullWidth>
              <InputLabel>{"Select RM"}</InputLabel>
            
              <Select value={rm}  label={"Select RM"} onChange={(e)=>{setRm(e.target.value);setOwner(e.target.value)}}>
                {rmOptions.map((option, i) => (
                  <MenuItem key={i} value={option?.id}>{option.name} - {option.username}</MenuItem>
                ))}
              </Select>
              </FormControl>}
              <FormControl fullWidth className='my-2'>
              <InputLabel>{"Party Type"}</InputLabel>
              <Select value={partyType}  label={"Party Type"} onChange={(e)=>{choosePartyType(e.target.value)}}>
                {partyTypeOptions.map((option, i) => (
                  <MenuItem key={i} value={option}>{option}</MenuItem>
                ))}
              </Select>
              </FormControl>
              {/* <button className='btn btn-info' onClick={()=>{selectPartyType()}}> Search Party</button> */}
        <button
          className='btn btn-info'
          onClick={()=>{selectPartyType(); setHasSearched(true)}}
          // disabled={!rm || !partyType}
        >
          Search Party
        </button>

      </div>}

         {selectPartyTab && <Paper>
          <button className='btn btn-primary' onClick={()=>{setSelectPartyTab(false)}}> back</button>
      <TableContainer>
        <Table>
          <TableHead >
            <TableRow >
              <TableCell className='text-white' sx={{ width: "70px" }}>S. No.</TableCell>
              <TableCell className='text-white' sx={{ width: "110px" }}>Party ID</TableCell>
              <TableCell className='text-white' sx={{ width: "320px" }}>Party Name</TableCell>
              {/* <TableCell className='text-white'>Mobile</TableCell> */}
              <TableCell className='text-white' sx={{ width: "200px" }}>Email</TableCell>
              <TableCell className='text-white' sx={{ width: "150px" }}>Mobile No.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partyOptions.map((party, ind) => (
              <TableRow key={party.id} onClick={()=>{chooseParty(party);setTab(1)}}>
                <TableCell style={{cursor:"pointer"}} sx={{ width: "70px" }}>{ind+1}</TableCell>
                <TableCell style={{cursor:"pointer"}} sx={{ width: "110px" }}>{partyType.toLowerCase()=='school'?party.schoolId:party.distributorID}</TableCell>
                <TableCell  style={{cursor:"pointer"}} sx={{ width: "320px" }}>{partyType.toLowerCase()=='school'?party.schoolName:party.DistributorName}</TableCell>
                {/* <TableCell  style={{cursor:"pointer"}}>{party?.makerContact?party?.makerContact : "N/A"}</TableCell> */}
                <TableCell  style={{cursor:"pointer"}}   sx={{
    width: "200px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  }}>{party?.email? party?.email : "N/A"}</TableCell>
                <TableCell  style={{cursor:"pointer"}} sx={{ width: "150px" }}>{party?.makerContact? party?.makerContact : "N/A"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 30, 50, 100]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>}
     
    </Container>
  );
}
